import { useInfiniteQuery } from '@tanstack/react-query';
import _merge from 'lodash/merge';

import { getOfferingsSearch, OfferingSearchResponse } from '@arrived/api_v2';
import { OfferingSearchQuery } from '@arrived/models';

import { UseInfiniteQueryOptions } from '../queries.utils';
import { offeringsInfiniteKeyFn } from './offerings.keys';

export function useOfferingSearchInfiniteQuery(
  query?: OfferingSearchQuery,
  options?: UseInfiniteQueryOptions<OfferingSearchResponse>
) {
  return useInfiniteQuery(
    offeringsInfiniteKeyFn(query),
    ({ pageParam = 1 }) => getOfferingsSearch(_merge({}, query, { page: pageParam })),
    {
      staleTime: 30_000,
      keepPreviousData: true,
      getNextPageParam: ({ pagination: { page, size, totalResults } }) =>
        page * size >= totalResults ? undefined : page + 1,
      ...options,
      onSuccess: (data) => {
        // TODO: re-enable this we can't cache for now because there are certain attributes that are missing on the
        //  offering model return from OpenSearch that we need elsewhere.

        // data.data?.forEach((offering) => {
        //   queryClient.setQueryData(offeringKeyFn(offering.id), offering, { updatedAt: Date.now() });
        //   queryClient.setQueryData(offeringKeyFn(offering.shortName), offering, { updatedAt: Date.now() });
        // });
        options?.onSuccess?.(data);
      },
    }
  );
}
